import React, { useState } from 'react';
import { Container, Grid, Alert } from '@mui/material';
import { useCurrency } from '../../contexts/CurrencyContext';
import { LAYOUT } from '../../constants/layout';
import useBalanceData from './hooks/useBalanceData';
import BalanceControls from './BalanceControls';
import BalanceKPICards from './BalanceKPICards';
import PeriodComparison from './PeriodComparison';
import CashFlowChart from './CashFlowChart';
import BalanceTable from './BalanceTable';

const BalanceDashboard = () => {
  const { currency: globalCurrency, setCurrency } = useCurrency();
  const [showValues, setShowValues] = useState(false);
  const [viewMode, setViewMode] = useState('monthly');

  const {
    loading,
    error,
    kpis,
    currentPeriod,
    previousPeriod,
    comparison,
    tableData,
  } = useBalanceData({
    viewMode,
    months: 24,
    currency: globalCurrency,
  });

  const handleCurrencyChange = (newCurrency) => {
    setCurrency(newCurrency);
  };

  return (
    <Container maxWidth={false} disableGutters sx={LAYOUT.PAGE_SPACING}>
      <BalanceControls
        showValues={showValues}
        onToggleVisibility={() => setShowValues(!showValues)}
        currency={globalCurrency}
        onCurrencyChange={handleCurrencyChange}
        viewMode={viewMode}
        onViewModeChange={setViewMode}
      />

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      <BalanceKPICards
        data={kpis}
        currency={globalCurrency}
        loading={loading}
        showValues={showValues}
      />

      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} md={5}>
          <PeriodComparison
            currentPeriod={currentPeriod}
            previousPeriod={previousPeriod}
            comparison={comparison}
            currency={globalCurrency}
            showValues={showValues}
            loading={loading}
            viewMode={viewMode}
          />
        </Grid>
        <Grid item xs={12} md={7}>
          <CashFlowChart
            data={tableData}
            currency={globalCurrency}
            showValues={showValues}
            loading={loading}
          />
        </Grid>
      </Grid>

      <BalanceTable
        data={tableData}
        currency={globalCurrency}
        showValues={showValues}
        loading={loading}
        viewMode={viewMode}
      />
    </Container>
  );
};

export default BalanceDashboard;
